import { ADD_IOR, SET_IORS } from './index.actions';
import { APP_INITIALIZATION } from '../core/base-actions';

export const namespace = 'iors';

export const reducer = (state = {}, action) => {
  switch (action.type) {
    case SET_IORS: {
      return {
        ...action.data,
      };
    }
    case APP_INITIALIZATION: {
      return {
        ...action?.initialData?.iors,
      };
    }
    case ADD_IOR: {
      return {
        ...state,
        [action?.newIorData?.id]: action?.newIorData,
      };
    }
    default: {
      return state;
    }
  }
};
